'use client';

import Image from 'next/image';
import { trackEvent } from '@/utils/analytics';

interface RouteImageProps {
  imageUrl: string;
}

export function RouteImage({ imageUrl }: RouteImageProps) {
  const trackRouteClick = () => {
    trackEvent({
      action: 'route_click',
      category: 'trip',
      label: imageUrl,
      value: 1,
    });
  };

  return (
    <button
      type="button"
      onClick={() => {
        trackRouteClick();
        window.open(imageUrl, '_blank');
      }}
      className="w-full"
      aria-label="View full route map in new tab"
    >
      <div className="aspect-[2/1] relative rounded-4xl overflow-hidden mb-8 cursor-pointer hover:opacity-90 transition-opacity">
        <Image
          src={imageUrl}
          alt="Detailed trip route map"
          fill
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 80vw, 70vw"
          className="object-cover"
        />
      </div>
    </button>
  );
}
